<template>
  <b-form class="d-flex" @submit="onSubmit">
    <b-input-group>
      <b-form-input v-model="text" :placeholder="placeholder" v-debounce:500ms="onSearch" />
      <b-input-group-append>
        <b-button variant="secondary" type="submit">
          <b-icon-search />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
export default {
  name: "SearchField",
  props: {
    placeholder: String,
    value: String,
  },
  data() {
    return {
      text: this.value ? this.value : "",
    };
  },
  methods: {
    onSearch(event) {
      this.$emit("onFormSubmit", this.text);
    },
    onSubmit(event) {
      event.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  display: flex;
  align-items: center;
  width: 44px;
  height: 44px;
}
.form-control {
  height: 44px;
}
</style>
